import React, { useMemo } from 'react';

import { UserRewindPersonFragmentFragment } from 'types/graphql-api.generated';

import { IMAGE_EMPTY_PHOTO_PORTRAIT } from 'common/configuration/constants';
import { getImageUrl } from 'common/tools/network/url';

import styles from '../../styles.module.scss';

type CelebrityPictureProps = {
  celebrity?: UserRewindPersonFragmentFragment;
  height?: number;
  width?: number;
  imgClassName?: string;
};

const DEFAULT_WIDTH = 206;
const DEFAULT_HEIGHT = 275;

const CelebrityPicture = ({
  celebrity,
  height,
  width,
  imgClassName
}: CelebrityPictureProps) => {
  const celebrityName = useMemo(
    () => `${celebrity?.firstName} ${celebrity?.lastName}`,
    [celebrity?.firstName, celebrity?.lastName]
  );

  const imgSrc = useMemo(
    () =>
      getImageUrl({
        src: celebrity?.picture?.path || IMAGE_EMPTY_PHOTO_PORTRAIT,
        format: {
          cw: width ?? DEFAULT_WIDTH,
          ch: height ?? DEFAULT_HEIGHT,
          grow: true
        }
      }),
    [celebrity?.picture?.path, height, width]
  );

  return (
    <div className={styles.celebrity}>
      <div className={styles.celebrityPicture}>
        <img src={imgSrc} alt={celebrityName ?? ''} className={imgClassName} />
      </div>
      <div className={styles.celebritySticker} />
    </div>
  );
};

export default CelebrityPicture;
